<template>
    <div>
        <form action="/just-giving/auth" method="post">
            <div class="form-group">

                <p>You've signed up for the event! Now let's make a bigger impact by setting up your JustGiving page.</p>
                <p>By connecting your account with JustGiving, you'll be able to:</p>
                <ul>
                    <li><strong>Easily create a fundraising page</strong> in just a few clicks</li>
                    <li><strong>Share your page</strong> with friends and family to start raising funds</li>
                    <li><strong>Track donations</strong> directly from your page and keep your supporters updated</li>
                </ul>
                <h4>What happens next:</h4>
                <ol>
                    <li><strong>Click 'Continue' to connect with JustGiving</strong>. You’ll be redirected to the JustGiving website, where you'll need to log in or sign up.</li>
                    <li><strong>Authorise the connection</strong>. JustGiving will ask for your permission to link your account. This allows us to automatically create your fundraising page for the event.</li>
                    <li><strong>Finish setting up your page</strong>. Once the connection is authorised, you'll be brought back here to complete your page setup.</li>
                </ol>
            </div>


            <button v-if="!checked" type="submit" class="btn btn-ar btn-primary">
                <i v-if="loading" class="fa fa-spinner fa-spin"></i>
                Continue
            </button>
        </form>
    </div>
</template>


<script>

import {bs} from "../../mixins/bs";

export default {
    name: "just-giving-authenticate",
    props: {
        participant: {
            type: Object,
            default: () => ({}),
            required: true
        },
        bs: {
            type: String,
            default: () => 'bs3',
            required: false
        },
    },
    components: {},
    mixins: [bs],
    data() {
        return {
            checked: false,
            loading: false,
            errors: [],
            verifiedCredentials: {
              accessToken: '',
            }
        }
    },
    computed: {
        verified: function () {
            return this.verifiedCredentials.email !== '';
        }
    },
    created() {

    },
    methods: {
        checkEmailPassword() {
            this.verifiedCredentials.accessToken = this.accessToken;
            this.$emit('authenticated', this.verifiedCredentials);
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/JustGivingCharities/Authenticate.vue